module.exports = __webpack_public_path__ + "img/icon_dban_zh.4f829cc2.png";